export default __webpack_public_path__ + "static/media/pool-res10.503db33e.jpg";